import { IconButton, makeStyles } from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import { FieldArray, useField } from 'formik'
import React from 'react'
import * as Yup from 'yup'

import {
  Button,
  Form,
  FormikTextField,
  Typography,
  FIELD_REQUIRED,
} from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  table: {
    borderSpacing: 0,
  },
  addAward: {
    marginTop: theme.spacing(1),
  },
  award: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
}))

export const validationSchema = () =>
  Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required(FIELD_REQUIRED),
      year: Yup.number().required(FIELD_REQUIRED).typeError('Invalid year'),
    })
  )

const AwardsForm = () => {
  const classes = useStyles()

  const [field] = useField({ name: 'awards' })
  const { value } = field

  return (
    <Form>
      <FieldArray
        name="awards"
        render={({ push, remove }) => (
          <>
            {value.length === 0 ? (
              <Typography>No awards</Typography>
            ) : (
              value.map(({ id, name, year }, idx) => (
                <div key={idx} className={classes.award}>
                  <FormikTextField
                    label="Name"
                    margin="dense"
                    name={`awards.${idx}.name`}
                  />
                  <FormikTextField
                    label="Year"
                    margin="dense"
                    name={`awards.${idx}.year`}
                  />
                  <IconButton onClick={() => remove(idx)}>
                    <DeleteIcon color="primary" />
                  </IconButton>
                </div>
              ))
            )}
            <Button
              className={classes.addAward}
              color="primary"
              onClick={() => push({ name: '', year: '' })}
              startIcon={<AddCircleIcon />}
              variant="outlined"
            >
              Add Award
            </Button>
          </>
        )}
      />
    </Form>
  )
}

export default AwardsForm
